import { useContext, useState } from 'react';

import RemoveModal from '../../../../Components/Modal/RemoveModal';
import { getRanks } from '../../../../Utils/Helpers';
import { CompetitionContext } from '../../Context/CompetitionContext';

const Ranks = ({
  ranks,
  removeRank,
  removeLoading,
  loadingSelectRank,
  setModalIsOpen,
  modalIsOpen,
  changeEthicsCard,
  competition,
  changeSportCard,
  onChangeRank,
}) => {
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const context = useContext(CompetitionContext);
  return (
    <>
      <div className='col-12 col-md-12' style={{ marginTop: '200px' }}>
        {/* <div className='d-flex flex-row align-items-end justify-content-center w-100'> */}
        {/* <div
            className='w-25 text-center d-flex flex-row justify-content-center align-items-center text-white f-20 border rounded-1'
            style={{
              height: '100px',
              position: 'relative',
              background: '#974B00',
            }}
          >
            سوم مشترک
            {ranks.find((r) => r.rank == 4) && (
              <div
                className='border border-successs rounded text-center text-white font-weight-bold w-100 bg-success p-3 f-13 d-flex flex-row justify-content-between'
                style={{ position: 'absolute', top: '-55px', left: 0 }}
              >
                {ranks.find((r) => r.rank == 4)?.type == 'team' ||
                ranks.find((r) => r.rank == 4)?.type == 'league'
                  ? 'تیم : '
                  : ''}
                {ranks.find((r) => r.rank == 4)?.title}
                <i
                  className='fal fa-trash text-white f-18 c-pointer'
                  onClick={() => {
                    setModalRemoveObject({
                      id: 4,
                      title: ranks.find((r) => r.rank == 4)?.title,
                    });
                    setModalIsOpen(true);
                  }}
                ></i>
              </div>
            )}
          </div>
          <div
            className='w-25 text-center d-flex flex-row justify-content-center align-items-center text-white f-20 border rounded-1'
            style={{
              height: '100px',
              position: 'relative',
              background: '#974B00',
            }}
          >
            سوم
            {ranks.find((r) => r.rank == 3) && (
              <div
                className='border border-successs rounded text-center text-white font-weight-bold w-100 bg-success p-3 f-13 d-flex flex-row justify-content-between'
                style={{ position: 'absolute', top: '-55px', left: 0 }}
              >
                {ranks.find((r) => r.rank == 3)?.type == 'team' ||
                ranks.find((r) => r.rank == 3)?.type == 'league'
                  ? 'تیم : '
                  : ''}
                {ranks.find((r) => r.rank == 3)?.title}
                <i
                  className='fal fa-trash text-white f-18 c-pointer'
                  onClick={() => {
                    setModalRemoveObject({
                      id: 3,
                      title: ranks.find((r) => r.rank == 3)?.title,
                    });
                    setModalIsOpen(true);
                  }}
                ></i>
              </div>
            )}
          </div>

          <div
            className='w-25  text-center d-flex flex-row justify-content-center align-items-center text-white f-20 border rounded-1'
            style={{
              height: '180px',
              position: 'relative',
              background: '#FFD600',
            }}
          >
            اول
            {ranks.find((r) => r.rank == 1) && (
              <div
                className='border border-successs rounded text-center text-white font-weight-bold w-100 bg-success p-3 f-13 d-flex flex-row justify-content-between'
                style={{ position: 'absolute', top: '-55px', left: 0 }}
              >
                {ranks.find((r) => r.rank == 1)?.type == 'team' ||
                ranks.find((r) => r.rank == 1)?.type == 'league'
                  ? 'تیم : '
                  : ''}
                {ranks.find((r) => r.rank == 1)?.title}
                <i
                  className='fal fa-trash text-white f-18 c-pointer'
                  onClick={() => {
                    setModalRemoveObject({
                      id: 1,
                      title: ranks.find((r) => r.rank == 1)?.title,
                    });
                    setModalIsOpen(true);
                  }}
                ></i>
              </div>
            )}
          </div>

          <div
            className='w-25  text-center d-flex flex-row justify-content-center align-items-center text-white f-20 border rounded-1'
            style={{
              height: '130px',
              position: 'relative',
              background: '#C0C0C0',
            }}
          >
            دوم
            {ranks.find((r) => r.rank == 2) && (
              <div
                className='border border-successs rounded text-center text-white font-weight-bold w-100 bg-success p-3 f-13 d-flex flex-row justify-content-between'
                style={{ position: 'absolute', top: '-55px', left: 0 }}
              >
                {ranks.find((r) => r.rank == 2)?.type == 'team' ||
                ranks.find((r) => r.rank == 2)?.type == 'league'
                  ? 'تیم : '
                  : ''}
                {ranks.find((r) => r.rank == 2)?.title}
                <i
                  className='fal fa-trash text-white f-18 c-pointer'
                  onClick={() => {
                    setModalRemoveObject({
                      id: 2,
                      title: ranks.find((r) => r.rank == 2)?.title,
                    });
                    setModalIsOpen(true);
                  }}
                ></i>
              </div>
            )}
          </div>
        </div> */}
        <div className='d-flex flex-column'>
          <h1 className='text-dark f-15 font-weight-bold mx-2'>مقام ها : </h1>
          <table className='table table-hover table-striped overflow-hidden rounded-1 shadow-sm text-left'>
            {ranks?.length > 0 ? (
              <>
                <thead className='thead-persian-green text-left'>
                  <tr>
                    <th>نوع</th>
                    <th>نام</th>
                    {/* <th>کارت اخلاق</th> */}
                    <th>رشته</th>
                    <th>وزن</th>
                    <th>رده سنی</th>
                    <th>استان</th>
                    <th>مقام</th>
                    <th>حذف</th>
                  </tr>
                </thead>
                <tbody>
                  {ranks?.map((rank, index) => (
                    <tr>
                      {/* <td className='d-flex flex-row align-items-center'>
                          {rank?.rank}
                          {rank?.rank == 1 ? (
                            <>
                              <span
                                className='badge badge-pill f-10 text-center d-flex flex-row justify-content-center align-items-center mx-2'
                                style={{
                                  background: 'yellow',
                                  width: '20px',
                                  height: '20px',
                                }}
                              >
                                طلا
                              </span>
                            </>
                          ) : rank?.rank == 2 ? (
                            <span
                              className='badge badge-pill text-white f-10 text-center d-flex flex-row justify-content-center align-items-center mx-2'
                              style={{
                                background: 'rgb(192, 192, 192)',
                                width: '20px',
                                height: '20px',
                              }}
                            >
                              نقره
                            </span>
                          ) : rank?.rank == 3 ? (
                            <span
                              className='badge badge-pill text-white f-10 text-center d-flex flex-row justify-content-center align-items-center mx-2'
                              style={{
                                background: 'rgb(151, 75, 0)',
                                width: '20px',
                                height: '20px',
                              }}
                            >
                              برنز
                            </span>
                          ) : rank?.rank == 4 ? (
                            <span
                              className='badge badge-pill text-white f-10 text-center d-flex flex-row justify-content-center align-items-center mx-2'
                              style={{
                                background: 'rgb(151, 75, 0)',
                                width: '20px',
                                height: '20px',
                              }}
                            >
                              برنز مشترک
                            </span>
                          ) : (
                            ''
                          )}
                        </td> */}
                      <td>
                        {rank?.type == 'team'
                          ? 'تیمی'
                          : rank?.type == 'league'
                          ? 'لیگ'
                          : rank?.type == 'user'
                          ? 'انفرادی'
                          : ''}
                      </td>
                      <td>{rank?.title}</td>
                      {/* <td>
                          <div class='checkbox d-flex flex-row justify-conetnt-center align-items-center'>
                            <input
                              defaultChecked={
                                rank?.ethics_card == 1 ? true : false
                              }
                              className='checkbox-flip'
                              type='checkbox'
                              id={`check-${rank?.rank}`}
                              onChange={(e) =>
                                changeEthicsCard(
                                  rank?.rank,
                                  e.target.checked ? 1 : 0,
                                )
                              }
                            />
                            <label
                              htmlFor={`check-${rank?.rank}`}
                              className='c-pointer'
                            >
                              <span></span>
                            </label>
                          </div>
                        </td> */}
                      <td>
                        <div class='checkbox d-flex flex-row justify-conetnt-center align-items-center'>
                          <select
                            value={rank?.sport_id}
                            className='form-control'
                            onChange={(e) =>
                              onChangeRank('sport_id', index, e.target?.value)
                            }
                          >
                            <option value={0}>انتخاب رشته</option>
                            {competition?.sports?.map((sport) => (
                              <option key={sport?.id} value={sport?.id}>
                                {sport?.title}
                              </option>
                            ))}
                          </select>
                        </div>
                      </td>
                      <td>
                        <div class='checkbox d-flex flex-row justify-conetnt-center align-items-center'>
                          <select
                            value={rank?.weight_id}
                            className='form-control'
                            onChange={(e) =>
                              onChangeRank('weight_id', index, e.target?.value)
                            }
                          >
                            <option value={0}>انتخاب وزن</option>
                            {competition?.weights?.map((weight) => (
                              <option key={weight?.id} value={weight?.id}>
                                {weight?.weight}
                              </option>
                            ))}
                          </select>
                        </div>
                      </td>
                      <td>
                        <div class='checkbox d-flex flex-row justify-conetnt-center align-items-center'>
                          <select
                            value={rank?.age_id}
                            className='form-control'
                            onChange={(e) =>
                              onChangeRank('age_id', index, e.target?.value)
                            }
                          >
                            <option value={0}>انتخاب رده سنی</option>
                            {competition?.ages?.map((age) => (
                              <option key={age?.id} value={age?.id}>
                                {age?.title}
                              </option>
                            ))}
                          </select>
                        </div>
                      </td>
                      <td>
                        <div class='checkbox d-flex flex-row justify-conetnt-center align-items-center'>
                          <select
                            value={rank?.province_id}
                            className='form-control'
                            onChange={(e) => {
                              onChangeRank(
                                'province_id',
                                index,
                                e.target?.value,
                              );
                            }}
                          >
                            <option value={0}>انتخاب استان</option>
                            {context?.provinces?.map((province) => (
                              <option key={province?.id} value={province?.id}>
                                {province?.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </td>
                      <td>
                        <div class='checkbox d-flex flex-row justify-conetnt-center align-items-center'>
                          <select
                            value={rank?.rank}
                            className='form-control'
                            onChange={(e) => {
                              onChangeRank('rank', index, e.target?.value);
                            }}
                          >
                            <option value={0}>انتخاب مقام</option>
                            {getRanks()?.map((rank) => (
                              <option key={rank?.value} value={rank?.value}>
                                {rank?.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </td>
                      <td>
                        <i
                          className='fal fa-trash text-danger f-18 c-pointer'
                          onClick={() => {
                            setModalRemoveObject({
                              id: rank?.id,
                              title: rank?.title,
                              index: index,
                            });
                            setModalIsOpen(true);
                          }}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </>
            ) : (
              <>
                <thead className='thead-persian-green text-left'>
                  <td></td>
                </thead>
                <tbody>
                  <tr>
                    <td className='d-flex flex-row justify-content-center'>
                      اطلاعاتی وجود ندارد
                    </td>
                  </tr>
                </tbody>
              </>
            )}
          </table>
        </div>
      </div>

      <RemoveModal
        id={modalRemoveObject}
        modalIsOpen={modalIsOpen}
        removeItem={removeRank}
        removeLoading={removeLoading}
        setModalIsOpen={setModalIsOpen}
        title={`آیا از حذف "${modalRemoveObject?.title}" مطمئن هستید ؟ درصورت حذف امکان برگشت نخواهد بود`}
      />
    </>
  );
};
export default Ranks;
